
export class CurrencyUtils {

    static getCurrencyUnit (currencyString) {

        switch (currencyString) {
            case 'ARS': return '$';
            case 'EUR': return '€';
            case 'CAD': return 'CAD $';
            case 'PLN': return 'zł';
            case 'UAH': return '₴';
            case 'BRL': return 'R$';
            case 'GBP': return '£';
            case 'HUF': return 'Ft';
            case 'CZK': return 'Kč';
            case 'RUB': return '₽';
            case 'JPY': return '円';
            case 'USD':
            default: return 'USD $';
        }
    }

    static getCurrencyWithUnitString (currency, unit) {

        let currencyString = CurrencyUtils.getCurrencyUnit(unit);
        let value = Number(currency);
        let isNegative = value < 0;
        let absoluteValue = Math.abs(value);
        let resultString;

        switch (unit) {
            case 'ARS':
                resultString = `${absoluteValue} ${currencyString}`;
                break;
            case 'EUR':
                resultString = `${absoluteValue}${currencyString}`;
                break;
            case 'CAD':
                resultString = `${currencyString}${absoluteValue}`;
                break;
            case 'PLN':
                resultString = `${absoluteValue} ${currencyString}`;
                break;
            case 'UAH':
                resultString = `${absoluteValue} ${currencyString}`;
                break;
            case 'BRL':
                resultString = `${currencyString} ${absoluteValue}`;
                break;
            case 'GBP':
                resultString = `${currencyString}${absoluteValue}`;
                break;
            case 'HUF':
                resultString = `${absoluteValue} ${currencyString}`;
                break;
            case 'RUB':
                resultString = `${absoluteValue} ${currencyString}`;
                break;
            case 'CZK':
                resultString = `${absoluteValue} ${currencyString}`;
                break;
            case 'USD':
                resultString = `${currencyString}${absoluteValue}`;
                break;
            default: resultString = `${absoluteValue} ${currencyString}`;
        }

        if (!isNegative) {
            return resultString;
        } else {
            return `- ${resultString}`;
        }
    }
}


// WEBPACK FOOTER //
// ./shared/utils/CurrencyUtils.js